import { OktaAuth } from '@okta/okta-auth-js';
import { useMemo } from 'react';

import { getCompanyData } from '@/app/shared/constants/companies';

export const useAppOktaAuth = (): OktaAuth => {
    const { environmentConfig } = getCompanyData();

    return useMemo(() => {
        return new OktaAuth({
          issuer: environmentConfig.issuer,
          clientId: environmentConfig.clientId,
          redirectUri: `${environmentConfig.baseUrl}/callback`,
          postLogoutRedirectUri: `${environmentConfig.baseUrl}/login`,
          ignoreLifetime: true,
        });
    }, []);
};
